export default __webpack_public_path__ + "static/media/hörtest-avatar-02.de15e92b.svg";